export const ALGOLIA_INDEXES_TO_EXPERIMENT: {
  [key: string]: string
} = {
  'products_mktplc_prod_DE_de':
    'alg_neuralsearch_test_products_mktplc_prod_DE_de',
  'products_prod_IT_it': 'alg_neuralsearch_test_products_prod_IT_it',
}
